import ProviderAPI from "../redux/ProviderAPI";

export const getPermission = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/permission/detail",
    data,
    token,
  });
  return result;
};

export const AddPermission = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/permission/addpermission",
    data,
    token,
  });
  return result;
};

export const DeletePermission = async (data, token) => {
  const result = await ProviderAPI({
    type: "DELETE",
    url: "/permission/deletePermission",
    data,
    token,
  });
  return result;
};

export const AddUser = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/permission/adduser",
    data,
    token,
  });
  return result;
};

export const getAccountUser = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/permission/accountuser",
    data,
    token,
  });
  return result;
};

export const DeleteUser = async (data, token) => {
  const result = await ProviderAPI({
    type: "DELETE",
    url: "/permission/deleteuser",
    data,
    token,
  });
  return result;
};

export const CreatePassword = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/permission/updatepassword",
    data,
    token,
  });
  return result;
};

export const GetUserandPermission = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/permission/getuserandpermission",
    data,
    token,
  });
  return result;
};

export const SendToEmail = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/permission/sendEmail",
    data,
    token,
  });
  return result;
};

export const PostVerify = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/permission/verify",
    data,
    token,
  });
  return result;
};

export const EditAccountUser = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/permission/updatuser",
    data,
    token,
  });
  return result;
};

export const GetUser = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/permission/getuser",
    data,
    token,
  });
  return result;
};

export const editPermission = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/permission/editPermission",
    data,
    token,
  });
  return result;
};

export const editUser = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/permission/editUser",
    data,
    token,
  });
  return result;
};
